import * as Mod1 from "./discourse/components/modal/move-solution-confirmation";
import * as Mod2 from "./discourse/components/modal/solved-removal-confirmation";
import * as Mod3 from "./discourse/components/solved-accept-answer-button";
import * as Mod4 from "./discourse/components/solved-accepted-answers";
import * as Mod5 from "./discourse/components/solved-accordion-item-metadata";
import * as Mod6 from "./discourse/components/solved-admin-report-related-items";
import * as Mod7 from "./discourse/components/solved-admin-report-table-summary-item";
import * as Mod8 from "./discourse/components/solved-shared-issue-button";
import * as Mod9 from "./discourse/components/solved-unaccept-answer-button";
import * as Mod10 from "./discourse/connectors/after-topic-status/solved-status.gjs";
import * as Mod11 from "./discourse/connectors/bread-crumbs-right/solved-status-filter.gjs";
import * as Mod12 from "./discourse/connectors/topic-navigation/no-answer.gjs";
import * as Mod13 from "./discourse/connectors/user-activity-bottom/solved-list.gjs";
import * as Mod14 from "./discourse/connectors/user-card-metadata/accepted-answers.gjs";
import * as Mod15 from "./discourse/connectors/user-preferences-notifications/solved-notifications.gjs";
import * as Mod16 from "./discourse/connectors/user-summary-stat/solved-count.gjs";
import * as Mod17 from "./discourse/initializers/add-topic-list-class";
import * as Mod18 from "./discourse/initializers/extend-for-solved-button";
import * as Mod19 from "./discourse/initializers/solved-admin-plugin-configuration-nav";
import * as Mod20 from "./discourse/initializers/solved-admin-report-related-items";
import * as Mod21 from "./discourse/initializers/solved-category-change-confirmation";
import * as Mod22 from "./discourse/initializers/solved-user-options";
import * as Mod23 from "./discourse/lib/set-accepted-solutions";
import * as Mod24 from "./discourse/pre-initializers/solved-move-confirmation";
import * as Mod25 from "./discourse/routes/user-activity/solved";
import * as Mod26 from "./discourse/solved-route-map";
import * as Mod27 from "./discourse/templates/user-activity/solved";
const compatModules = {
  "discourse/components/modal/move-solution-confirmation": Mod1,
  "discourse/components/modal/solved-removal-confirmation": Mod2,
  "discourse/components/solved-accept-answer-button": Mod3,
  "discourse/components/solved-accepted-answers": Mod4,
  "discourse/components/solved-accordion-item-metadata": Mod5,
  "discourse/components/solved-admin-report-related-items": Mod6,
  "discourse/components/solved-admin-report-table-summary-item": Mod7,
  "discourse/components/solved-shared-issue-button": Mod8,
  "discourse/components/solved-unaccept-answer-button": Mod9,
  "discourse/connectors/after-topic-status/solved-status": Mod10,
  "discourse/connectors/bread-crumbs-right/solved-status-filter": Mod11,
  "discourse/connectors/topic-navigation/no-answer": Mod12,
  "discourse/connectors/user-activity-bottom/solved-list": Mod13,
  "discourse/connectors/user-card-metadata/accepted-answers": Mod14,
  "discourse/connectors/user-preferences-notifications/solved-notifications": Mod15,
  "discourse/connectors/user-summary-stat/solved-count": Mod16,
  "discourse/initializers/add-topic-list-class": Mod17,
  "discourse/initializers/extend-for-solved-button": Mod18,
  "discourse/initializers/solved-admin-plugin-configuration-nav": Mod19,
  "discourse/initializers/solved-admin-report-related-items": Mod20,
  "discourse/initializers/solved-category-change-confirmation": Mod21,
  "discourse/initializers/solved-user-options": Mod22,
  "discourse/lib/set-accepted-solutions": Mod23,
  "discourse/pre-initializers/solved-move-confirmation": Mod24,
  "discourse/routes/user-activity/solved": Mod25,
  "discourse/solved-route-map": Mod26,
  "discourse/templates/user-activity/solved": Mod27,
};
export default compatModules;
